import elementService from "@/common/ElementService";
import popupAlertService from "@/common/PopupAlertService";

export default new class ValueClipboardCopyService {
    public init(): void {
        for (const element of document.querySelectorAll<HTMLElement>(".js-copy-to-clipboard")) {
            element.addEventListener("click", () => this.copyToClipboard(element));
        }
    }

    public copyValueToClipboard(valueToCopyToClipboard: string, element: HTMLElement): void {
        try {
            void navigator.clipboard.writeText(valueToCopyToClipboard);
            this.showPopupClipboardCopySuccessNotification(element);
        } catch (error) {
            void popupAlertService.showAlert(`Nepodařilo se zkopírovat text do schránky. Zkuste to prosím ručně. Důvod: ${error instanceof Error ? error.message : "Neznámý"}`);
        }
    }

    private copyToClipboard(element: HTMLElement): void {
        const valueToCopyToClipboard = element.dataset.clipboardCopyValue;
        const selectorToCopyToClipboard = element.dataset.clipboardCopyValueSelector;

        if (valueToCopyToClipboard !== undefined) {
            this.copyToClipboardFromValue(valueToCopyToClipboard, element);
        } else if (selectorToCopyToClipboard !== undefined) {
            this.copyToClipboardInnerHTMLOf(selectorToCopyToClipboard, element);
        } else {
            throw new Error("Invalid clipboard value or selector");
        }
    }

    private copyToClipboardFromValue(valueToCopyToClipboard: string, element: HTMLElement): void {
        this.copyValueToClipboard(valueToCopyToClipboard, element);
    }

    private copyToClipboardInnerHTMLOf(selectorToCopyToClipboard: string, element: HTMLElement): void {
        void globalThis.navigator.clipboard.writeText(elementService.querySelector<HTMLElement>(selectorToCopyToClipboard).innerHTML);
        this.showPopupClipboardCopySuccessNotification(element);
    }

    private showPopupClipboardCopySuccessNotification(element: HTMLElement): void {
        const rect = element.getBoundingClientRect();

        const container = document.createElement("div");
        container.className = "notification-container";
        container.style.top = `${rect.bottom + 8}px`;
        container.style.left = `${rect.left + (rect.width / 2)}px`;
        container.style.transform = "translateX(-50%)";
        container.style.pointerEvents = "none";

        document.body.appendChild(container);

        const notif = document.createElement("div");
        notif.className = "notification success";
        notif.style.pointerEvents = "auto";

        const icon = document.createElement("i");
        icon.className = "fa-regular fa-clipboard";

        notif.appendChild(icon);
        notif.appendChild(document.createTextNode(" Zkopírováno do schránky."));
        container.appendChild(notif);

        setTimeout(() => {
            notif.remove();
            container.remove();
        }, 2000);
    }
}();
